import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { PHONE_NUMBER, WHATSAPP_NUMBER, GALLERY_IMAGES } from '../../config/constants';

const Hero = () => {
  return (
    <section 
      id="home" 
      className="relative h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img 
          src={GALLERY_IMAGES[2]} 
          alt="Roger's Club Barberia" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>
      
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <div className="mb-8 animate-fade-in">
          <div className="text-6xl md:text-8xl font-serif font-bold mb-4 tracking-wider">
            ROGER'S <span className="text-amber-500">CLUB</span>
          </div>
          <div className="text-2xl md:text-3xl font-serif tracking-widest text-white mb-2">BARBERIA</div>
          <div className="text-lg md:text-xl tracking-widest text-amber-500">GENTLEMAN CLUB</div>
        </div>
        
        <h1 className="text-3xl md:text-5xl font-serif mb-6 leading-tight animate-fade-in-up">
          Più di una barberia.<br />
          <span className="text-amber-500">Un'esperienza.</span>
        </h1>
        
        <p className="text-lg md:text-xl mb-10 text-gray-300 max-w-2xl mx-auto animate-fade-in-up">
          Identità, esperienza, visione che va oltre la professione.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up">
          <Button 
            onClick={() => window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank')}
            className="bg-amber-500 hover:bg-amber-600 text-black font-semibold px-8 py-6 text-lg rounded-none transition-all hover:scale-105"
            data-testid="hero-book-btn"
          >
            Prenota Ora
          </Button>
          <Button 
            onClick={() => window.location.href = `tel:${PHONE_NUMBER}`}
            variant="outline"
            className="border-2 border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black font-semibold px-8 py-6 text-lg rounded-none transition-all hover:scale-105"
            data-testid="hero-call-btn"
          >
            <Phone className="mr-2" size={20} />
            Chiama Ora
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-amber-500 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-amber-500 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
